// extracted by mini-css-extract-plugin
export default {"LoadingAuth":"LoadingAuth_LoadingAuth__hsDnZ","container":"LoadingAuth_container__379l2"};